import { getFilterValueAngularStyle } from "@/features/company/utils/companyValidators";
import type { BuildIntegrationsCompanyPayloadOptions, IntegrationsFormState } from '../types'

/**
 * Same POST /api/company/:id shape as Integrations / Config tabs: filtered integration fields + Angular full-form parity.
 * Optional `itrratio` is merged like Preferences when saving from Config tab as admin.
 * Config tab passes invitation fields from the loaded `company` object so it stays in sync with the Integrations tab.
 */
export function buildIntegrationsCompanyPayload(
    company: Record<string, unknown> | null | undefined,
    formData: IntegrationsFormState,
    options?: BuildIntegrationsCompanyPayloadOptions,
): Record<string, unknown> {
    const raw: Record<string, unknown> = {
        activate_api: String(formData.activate_api ?? "").trim(),
        invitation_api_key: String(formData.invitation_api_key ?? "").trim(),
    };
    if (options?.itrratio !== undefined) {
        raw.itrratio = options.itrratio;
    }
    const payload = getFilterValueAngularStyle(raw) as Record<string, unknown>;

    payload.federal_id =
        company?.federal_id != null && String(company.federal_id).trim() !== ""
            ? String(company.federal_id).trim()
            : "";

    if (company?.listed != null && String(company.listed).trim() !== "") {
        payload.listed = String(company.listed).trim();
    }
    if (company?.company_name != null && String(company.company_name).trim() !== "") {
        payload.company_name = String(company.company_name).trim();
    }
    if (company?.c_aln_ref_id != null && String(company.c_aln_ref_id).trim() !== "") {
        payload.c_aln_ref_id = company.c_aln_ref_id;
    }
    if (company?.website_url != null && String(company.website_url).trim() !== "") {
        payload.website_url = company.website_url;
    }

    payload.is_mailing_address =
        company?.is_mailing_address === "1" ||
        company?.is_mailing_address === true ||
        company?.is_mailing_address === 1
            ? 1
            : 0;
    payload.check_exist = true;

    return payload;
}
